module.exports = __webpack_public_path__ + "img/split-order-checkbox-off.be495c8b.svg";